// extracted by mini-css-extract-plugin
export default {"wrapper":"AFGP4ArHYIdzUYhJbrsf"};